import axios from "./apiClient";
const apiUrl = process.env.REACT_APP_API_URL;
const API_URL = `${apiUrl}/users`;
const API_URL_PROPERTIES = `${apiUrl}`;

const fetchUsers = async (page, pageSize, year) => {
  const response = await axios.get(
    `${API_URL}?page=${page}&pageSize=${pageSize}${year ? `&year=${year}` : ""}`
  );
  return response.data;
};

const fetchArchivedUsers = async (page, pageSize, year) => {
  const response = await axios.get(
    `${apiUrl}/users/archived?page=${page}&pageSize=${pageSize}${
      year ? `&year=${year}` : ""
    }`
  );
  return response.data;
};

const fetchAllUsers = async (page, pageSize, year) => {
  const response = await axios.get(
    `${apiUrl}/users/all?page=${page}&pageSize=${pageSize}${
      year ? `&year=${year}` : ""
    }`
  );
  return response.data;
};

const fetchPaySlipMetaList = async () => {
  const response = await axios.get(
    `${API_URL_PROPERTIES}/getPropertiesAndDeductions`
  );
  return response.data;
};

const addPropertiesData = async (type, name) => {
  let endpoint = "";

  if (type === "properties") {
    endpoint = "property/add";
  } else if (type === "additions") {
    endpoint = "property/addAdditionType";
  } else if (type === "deductions") {
    endpoint = "property/addDeductionType";
  } else {
    return {
      status: 0,
      message: "Invalid type provided",
    };
  }

  const response = await axios.post(`${API_URL_PROPERTIES}/${endpoint}`, {
    name,
  });
  return response.data;
};
const deletePropertyMetaData = async (id, type) => {
  const endpoint = "propermetadata/delete";
  const response = await axios.post(`${API_URL_PROPERTIES}/${endpoint}`, {
    id,
    type,
  });
  return response.data;
};

const fetchUserCount = async () => {
  const response = await axios.get(`${API_URL}/count`);
  return response.data.length;
};

const fetchArchivedUserCount = async () => {
  const response = await axios.get(`${apiUrl}/users/archived/count`);
  return response.data.length;
};

const fetchAllUserCount = async () => {
  const response = await axios.get(`${apiUrl}/users/all/count`);
  return response.data.length;
};

export {
  fetchUsers,
  fetchArchivedUsers,
  fetchAllUsers,
  fetchUserCount,
  fetchArchivedUserCount,
  fetchAllUserCount,
  fetchPaySlipMetaList,
  addPropertiesData,
  deletePropertyMetaData,
};
